import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppState, useAppDispatch } from '../../../../services/store';
import { fetchWaterBodyDefinitions } from '../../../../services/store/modules/prepare';
import { getWaterBodyDefinitions } from '../../../../services/store/modules/prepare/selectors';

const useWaterBodyDefinitions = (): {
  waterBodyDefinitions: AppState['prepare']['waterBodyDefinitions'];
} => {
  const dispatch = useAppDispatch();

  const waterBodyDefinitions = useSelector(getWaterBodyDefinitions);

  useEffect(() => {
    dispatch(fetchWaterBodyDefinitions());
  }, [dispatch]);

  return {
    waterBodyDefinitions,
  };
};

export default useWaterBodyDefinitions;
